import intlTelInput from "intl-tel-input";

export default function intlTel({main, on, elm}) {
	const input = elm.querySelector("input");
	let iti;

	main(async _ => {
		await init();
	});

	const init = async function() {
		iti = intlTelInput(input, {
			separateDialCode: false,
			initialCountry: 'pl',
			customPlaceholder,
			loadUtils: () => import("intl-tel-input/utils"),
		});

		await iti.promise;
		elm.iti = iti;
	};

	elm.setNumber = function(number) {
		iti.setNumber(number);
	};

	const initialCountryLookup = async function () {
		const res = await fetch("index.php?route=extension/evasota/common/country");
		const data = await res.json();
		return data.hasOwnProperty('country_code') ? data.country_code : 'pl';
	};

	const customPlaceholder = function (exampleNumber, selectedCountry) {
		return exampleNumber ? exampleNumber : input.dataset.initPlaceholder;
	}
};

export const model = {};
